const GLOBAL_SEARCH_ENDPOINT = '/aic_one_api/system_management/global_search/';

const PLATFORM_HOST_ENV_VALUES = Object.freeze([
  process.env.VUE_APP_ORCAA_URL,
  process.env.VUE_APP_PROBA_WORKFLOWS_URL,
  process.env.VUE_APP_COMPLYON_URL,
  process.env.VUE_APP_ENGAGENET_URL,
  process.env.VUE_APP_X_VERDICT_URL,
  process.env.VUE_APP_PROBA_ANALYTICS_URL,
]);

const PLATFORM_LAUNCH_EXECUTORS = Object.freeze(Object.assign(Object.create(null), {
  'x-verdict': (options) => fetch(`${api_base_prefix()}/aic_one_api/system_management/launch_xverdict/`, options),
  orcaa: (options) => fetch(`${api_base_prefix()}/aic_one_api/system_management/launch_orcaa/`, options),
  proba: (options) => fetch(`${api_base_prefix()}/aic_one_api/system_management/launch_proba/`, options),
  engagenet: (options) => fetch(`${api_base_prefix()}/aic_one_api/system_management/launch_engagenet/`, options),
  workflow: (options) => fetch(`${api_base_prefix()}/aic_one_api/system_management/launch_proba_workflow/`, options),
  complyon: (options) => fetch(`${api_base_prefix()}/aic_one_api/system_management/launch_complyon/`, options),
  complyon_onboard: (options) => fetch(`${api_base_prefix()}/aic_one_api/system_management/launch_complyon_onboard/`, options),
}));

function api_base_prefix() {
  return String(process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/, '');
}

function global_search_query_string({ query, offset, expand, include, limit }) {
  const params = new URLSearchParams();
  params.set('search_query', String(query || '').trim());
  params.set('include', include);
  params.set('limit', String(expand ? 30 : limit));
  params.set('offset', String(offset));
  return params.toString();
}

function global_search_request_options(token) {
  return ({
    method: 'GET',
    credentials: 'include',
    headers: {
      'Authorization': `Token ${token}`,
      'X-Page-URL': window.location.href,
    },
  });
}

export function build_global_search_request(params) {
  const query_string = global_search_query_string(params);
  const options = global_search_request_options(params.token);
  return () => fetch(`${api_base_prefix()}${GLOBAL_SEARCH_ENDPOINT}?${query_string}`, options);
}

function platform_launch_request_options({ token, csrfHeaders, userId }) {
  return ({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`,
      'X-Page-URL': window.location.href,
      ...csrfHeaders,
    },
    body: JSON.stringify({ user_id: userId }),
  });
}

export function build_platform_launch_request({ platform, token, csrfHeaders, userId }) {
  if (!Reflect.has(PLATFORM_LAUNCH_EXECUTORS, platform)) {
    throw new Error('Invalid platform launch endpoint');
  }

  const execute_launch = Reflect.get(PLATFORM_LAUNCH_EXECUTORS, platform);
  const options = platform_launch_request_options({ token, csrfHeaders, userId });
  return () => execute_launch(options);
}

function host_from_url(value) {
  try {
    return new URL(value).hostname;
  } catch {
    return '';
  }
}

export function allowed_platform_launch_hosts() {
  return PLATFORM_HOST_ENV_VALUES.map(host_from_url).filter(Boolean);
}

function parse_platform_launch_url(raw_url) {
  try {
    return new URL(raw_url);
  } catch {
    return null;
  }
}

function is_https_url(url) {
  return Boolean(url) && url.protocol === 'https:';
}

function is_allowed_platform_host(hostname) {
  return allowed_platform_launch_hosts().some(
    (allowed_host) => allowed_host === hostname
  );
}

export function is_allowed_platform_launch_url(raw_url) {
  const url = parse_platform_launch_url(raw_url);

  if (!is_https_url(url)) {
    return false;
  }

  return is_allowed_platform_host(url.hostname);
}

export function safe_platform_launch_redirect_url(raw_url) {
  if (!is_allowed_platform_launch_url(raw_url)) return '';
  return new URL(raw_url).toString();
}
